import React, { FC, ReactNode } from 'react';
import './RestoreButton.css';
import { FaTrashRestore } from '@/Shared/Lib/UI/Icons';
import { ActionButton } from '..';

interface RestoreButtonProps {
	onClick: () => void;
	isLoading?: boolean;
	icon?: ReactNode,
	tooltip? : string,
	label ? : string,
	showLabel? : boolean
}

const RestoreButton: FC<RestoreButtonProps> = ({ 
	onClick, 
	isLoading, 
	icon = <FaTrashRestore />, 
	tooltip = "Bouton de restauration",
	label="Restaurer", 
	showLabel=false
}) => (
	<ActionButton
		classNames="RestoreButton"
		icon={icon}
		label={label}
		onClick={onClick}
		isLoading={isLoading}
		tooltip={tooltip}
		showLabel={showLabel}
	/>
);

export default RestoreButton;
